export const _setEmployee = (state, action) => {
  state.employee = action.payload;
};
